import {
  GET_DOCUMENTS,
  GET_DOCUMENTS_SUCCESS,
  GET_DOCUMENTS_FAIL,
  CREATE_DOCUMENT,
  CREATE_DOCUMENT_SUCCESS,
  CREATE_DOCUMENT_FAIL,
  GET_DOCUMENT,
  GET_DOCUMENT_SUCCESS,
  GET_DOCUMENT_FAIL,
  UPDATE_DOCUMENT,
  UPDATE_DOCUMENT_SUCCESS,
  UPDATE_DOCUMENT_FAIL,
  DELETE_DOCUMENT,
  DELETE_DOCUMENT_SUCCESS,
  DELETE_DOCUMENT_FAIL,
  GET_COMPANY_DOCUMENTS,
  GET_MY_DOCUMENTS,
  ASSIGN_DOCUMENT_COMPANIES,
  ASSIGN_DOCUMENT_COMPANIES_SUCCESS,
  ASSIGN_DOCUMENT_COMPANIES_FAIL,
  CLEAR_DOCUMENT_ERRORS,
  CLEAR_DOCUMENTS,
  GET_DOCUMENTS_ALL,
  GET_DOCUMENTS_ALL_SUCCESS,
  GET_DOCUMENTS_ALL_FAIL
} from "./actionTypes"

export const getDocumentsAll = params => ({
  type: GET_DOCUMENTS_ALL,
  payload: params
})

export const getDocumentsAllSuccess = data => ({
  type: GET_DOCUMENTS_ALL_SUCCESS,
  payload: data
})

export const getDocumentsAllFail = error => ({
  type: GET_DOCUMENTS_ALL_FAIL,
  payload: error
})

export const getDocuments = params => ({
  type: GET_DOCUMENTS,
  payload: params
})

export const getDocumentsSuccess = data => ({
  type: GET_DOCUMENTS_SUCCESS,
  payload: data
})

export const getDocumentsFail = error => ({
  type: GET_DOCUMENTS_FAIL,
  payload: error
})

export const createDocumentRequest = (data, history, getDocuments) => ({
  type: CREATE_DOCUMENT,
  payload: { data, history, getDocuments },
})

export const createDocumentSuccess = data => ({
  type: CREATE_DOCUMENT_SUCCESS,
  payload: data
})

export const createDocumentFail = error => ({
  type: CREATE_DOCUMENT_FAIL,
  payload: error
})

export const getDocument = id => ({
  type: GET_DOCUMENT,
  payload: { id }
})

export const getDocumentSuccess = data => ({
  type: GET_DOCUMENT_SUCCESS,
  payload: data
})

export const getDocumentFail = error => ({
  type: GET_DOCUMENT_FAIL,
  payload: error
})

export const updateDocument = (id, data, history, getDocuments) => ({
  type: UPDATE_DOCUMENT,
  payload: { id, data, history, getDocuments },
})

export const updateDocumentSuccess = data => ({
  type: UPDATE_DOCUMENT_SUCCESS,
  payload: data
})

export const updateDocumentFail = error => ({
  type: UPDATE_DOCUMENT_FAIL,
  payload: error
})

export const deleteDocument = (history, getDocuments, docId) => ({
  type: DELETE_DOCUMENT,
  payload: { history, getDocuments, docId },
})

export const deleteDocumentSuccess = data => ({
  type: DELETE_DOCUMENT_SUCCESS,
  payload: data
})

export const deleteDocumentFail = error => ({
  type: DELETE_DOCUMENT_FAIL,
  payload: error
})

export const getCompanyDocuments = (companyId, params) => ({
  type: GET_COMPANY_DOCUMENTS,
  payload: { companyId, params },
})

export const getMyDocuments = params => ({
  type: GET_MY_DOCUMENTS,
  payload: params || {},
})

export const assignDocumentCompanies = (id, companyIds, getDocuments) => ({
  type: ASSIGN_DOCUMENT_COMPANIES,
  payload: { id, companyIds, getDocuments },
})

export const assignDocumentCompaniesSuccess = data => ({
  type: ASSIGN_DOCUMENT_COMPANIES_SUCCESS,
  payload: data,
})

export const assignDocumentCompaniesFail = error => ({
  type: ASSIGN_DOCUMENT_COMPANIES_FAIL,
  payload: error,
})

export const clearDocumentErrors = () => ({
  type: CLEAR_DOCUMENT_ERRORS
})

export const clearDocuments = () => ({
  type: CLEAR_DOCUMENTS
})
